import { connect } from 'react-redux';
import _ from 'lodash';
import UserGroupsAutoCompleteView from './UserGroupsAutoCompleteView.jsx';
import { searchUserGroupForAutoComplete, invalidateAutoCompleteUserGroup } from '../../redux/actions/search.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.users.me,
    loading: _.get(state.legacyRootReducer, "search.userGroupSelection.searching"),
    userGroups: _.get(state.legacyRootReducer, "search.userGroupSelection.items"),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchUserGroupForAutoComplete: (query, showAll) => {
      return dispatch(searchUserGroupForAutoComplete(query, showAll))
    },

    invalidateAutoCompleteUserGroup: () => {
      return dispatch(invalidateAutoCompleteUserGroup())
    }
  }
}

const UserGroupsAutoCompleteContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {withRef: true}
)(UserGroupsAutoCompleteView);

export default UserGroupsAutoCompleteContainer;